export default __webpack_public_path__ + "static/media/sup-token.88873447.svg";